(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('MedalTag', MedalTag);

    MedalTag.$inject = ['$resource'];

    function MedalTag ($resource) {
        var resourceUrl =  'api/tags/:action/:medalId/:tagId';

        /**
         * POST - /api/tags/add-medal-tag/:medalId/:tagId
         DEL - /api/tags/remove-medal-tag/:medalId/:tagId
         GET - /api/tags/medal-tags/:medalId
         */
        return $resource(resourceUrl, {}, {
            tagsAvailable : { params:{action:'all-tags'},method : 'GET', isArray: true },
            allMedalTags : { params:{action:'medal-tags'},method : 'GET', isArray: true },
            addTag : { params:{action:'add-medal-tag'},method : 'POST' },
            removeTag : { params:{action:'remove-medal-tag'},method : 'DELETE' },


/*
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }*/
        });
    }
})();
